import {ValueObject} from '@s-ui/domain'

export class SubscriptionsParamsRequest extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.newSubscriptions
   * @param {String} data.subscriptionType
   * @param {String} data.userId
   * @param {String} data.token
   **/

  static validate({userId, token, subscriptionsUserError}) {
    const checkValidData = value => value !== null && value !== undefined && value !== ''
    if (!checkValidData(userId)) throw subscriptionsUserError('userId is required')
    if (!checkValidData(token)) throw subscriptionsUserError('token is required')
  }
}
